import React from 'react';
import { Link } from 'react-router-dom';
import { ShieldIcon, CreditCardIcon, BarChart3Icon, QrCodeIcon, CheckCircleIcon } from 'lucide-react';
const LandingPage = () => {
  return <div className="w-full" data-id="element-1336">
      {/* Hero Section */}
      <section className="bg-[#0D3B66] text-white relative overflow-hidden" data-id="element-1337">
        <div className="absolute inset-0 bg-gradient-to-br from-[#0D3B66] via-[#1565C0] to-[#0D3B66] opacity-50" data-id="element-1338"></div>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 md:py-28 relative z-10" data-id="element-1339">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center" data-id="element-1340">
            <div data-id="element-1341">
              <div className="mb-8" data-id="element-1342"></div>
              <h1 className="text-4xl md:text-5xl font-bold mb-6 leading-tight" data-id="element-1343">
                Enterprise Payment Solutions for Modern Merchants
              </h1>
              <p className="text-xl mb-8 text-white/90 leading-relaxed" data-id="element-1344">
                Securely manage transactions, generate payment requests, and
                gain valuable insights with our comprehensive merchant portal.
              </p>
              <div className="flex flex-col sm:flex-row space-y-4 sm:space-y-0 sm:space-x-4" data-id="element-1345">
                <Link to="/onboarding" className="bg-[#F5A623] text-[#0D3B66] px-8 py-4 rounded-md font-semibold text-center hover:bg-[#FFD54F] transition-colors shadow-lg" data-id="element-1346">
                  Get Started
                </Link>
                <Link to="/login" className="border-2 border-white text-white px-8 py-4 rounded-md font-semibold text-center hover:bg-white hover:text-[#0D3B66] transition-colors" data-id="element-1347">
                  Sign In
                </Link>
              </div>
            </div>
            <div className="hidden md:block" data-id="element-1348">
              <img src="https://cdn.magicpatterns.com/uploads/mPcdczhiT3jadrfZeU9Rey/ChatGPT_Image_Mar_8,_2026,_06_50_57_AM.png" alt="Merchant payment terminal with QR code" className="rounded-xl shadow-2xl" data-id="element-1349" />
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="py-20 bg-white" data-id="element-1350">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1351">
          <div className="text-center mb-16" data-id="element-1352">
            <h2 className="text-3xl md:text-4xl font-bold text-[#0D3B66] mb-4" data-id="element-1353">
              Powerful Features for Your Business
            </h2>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto" data-id="element-1354">
              Everything you need to manage payments and grow your business
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-1355">
            <div className="bg-[#F8FAFC] p-8 rounded-xl border border-[#E2E8F0] hover:shadow-lg transition-shadow" data-id="element-1356">
              <div className="w-14 h-14 bg-[#0D3B66]/10 rounded-xl flex items-center justify-center mb-6" data-id="element-1357">
                <ShieldIcon className="h-7 w-7 text-[#0D3B66]" data-id="element-1358" />
              </div>
              <h3 className="text-xl font-semibold text-[#0D3B66] mb-3" data-id="element-1359">
                Secure Compliance
              </h3>
              <p className="text-gray-600" data-id="element-1360">
                Meet all AML, KYC, and CFT requirements with our streamlined
                onboarding process.
              </p>
            </div>
            <div className="bg-[#F8FAFC] p-8 rounded-xl border border-[#E2E8F0] hover:shadow-lg transition-shadow" data-id="element-1361">
              <div className="w-14 h-14 bg-[#0D3B66]/10 rounded-xl flex items-center justify-center mb-6" data-id="element-1362">
                <CreditCardIcon className="h-7 w-7 text-[#0D3B66]" data-id="element-1363" />
              </div>
              <h3 className="text-xl font-semibold text-[#0D3B66] mb-3" data-id="element-1364">
                Payment Processing
              </h3>
              <p className="text-gray-600" data-id="element-1365">
                Accept multiple payment methods and manage transactions with
                ease.
              </p>
            </div>
            <div className="bg-[#F8FAFC] p-8 rounded-xl border border-[#E2E8F0] hover:shadow-lg transition-shadow" data-id="element-1366">
              <div className="w-14 h-14 bg-[#0D3B66]/10 rounded-xl flex items-center justify-center mb-6" data-id="element-1367">
                <BarChart3Icon className="h-7 w-7 text-[#0D3B66]" data-id="element-1368" />
              </div>
              <h3 className="text-xl font-semibold text-[#0D3B66] mb-3" data-id="element-1369">
                Detailed Analytics
              </h3>
              <p className="text-gray-600" data-id="element-1370">
                Gain insights with comprehensive transaction analytics and
                reporting tools.
              </p>
            </div>
            <div className="bg-[#F8FAFC] p-8 rounded-xl border border-[#E2E8F0] hover:shadow-lg transition-shadow" data-id="element-1371">
              <div className="w-14 h-14 bg-[#0D3B66]/10 rounded-xl flex items-center justify-center mb-6" data-id="element-1372">
                <QrCodeIcon className="h-7 w-7 text-[#0D3B66]" data-id="element-1373" />
              </div>
              <h3 className="text-xl font-semibold text-[#0D3B66] mb-3" data-id="element-1374">
                QR Code Payments
              </h3>
              <p className="text-gray-600" data-id="element-1375">
                Generate static and dynamic QR codes for seamless payment
                collection.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Onboarding Process Section */}
      <section className="py-20 bg-[#F8FAFC]" data-id="element-1376">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1377">
          <div className="text-center mb-16" data-id="element-1378">
            <h2 className="text-3xl md:text-4xl font-bold text-[#0D3B66] mb-4" data-id="element-1379">
              Simple Onboarding Process
            </h2>
            <p className="text-xl text-gray-600" data-id="element-1380">
              Get started in just a few easy steps
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-1381">
            <div className="bg-white p-8 rounded-xl shadow-sm border border-[#E2E8F0]" data-id="element-1382">
              <div className="w-12 h-12 bg-[#0D3B66] text-white rounded-full flex items-center justify-center mb-6 text-xl font-bold" data-id="element-1383">
                1
              </div>
              <h3 className="text-xl font-semibold text-[#0D3B66] mb-3" data-id="element-1384">
                Business Information
              </h3>
              <p className="text-gray-600" data-id="element-1385">
                Enter your business details, including name, address, and tax
                information.
              </p>
            </div>
            <div className="bg-white p-8 rounded-xl shadow-sm border border-[#E2E8F0]" data-id="element-1386">
              <div className="w-12 h-12 bg-[#0D3B66] text-white rounded-full flex items-center justify-center mb-6 text-xl font-bold" data-id="element-1387">
                2
              </div>
              <h3 className="text-xl font-semibold text-[#0D3B66] mb-3" data-id="element-1388">
                Account Setup
              </h3>
              <p className="text-gray-600" data-id="element-1389">
                Provide your banking details and select your preferred payment
                methods.
              </p>
            </div>
            <div className="bg-white p-8 rounded-xl shadow-sm border border-[#E2E8F0]" data-id="element-1390">
              <div className="w-12 h-12 bg-[#0D3B66] text-white rounded-full flex items-center justify-center mb-6 text-xl font-bold" data-id="element-1391">
                3
              </div>
              <h3 className="text-xl font-semibold text-[#0D3B66] mb-3" data-id="element-1392">
                Verification
              </h3>
              <p className="text-gray-600" data-id="element-1393">
                Upload necessary documents and complete the compliance
                screening.
              </p>
            </div>
          </div>
          <div className="text-center mt-12" data-id="element-1394">
            <Link to="/onboarding" className="inline-flex items-center bg-[#F5A623] text-[#0D3B66] px-8 py-4 rounded-md font-semibold hover:bg-[#FFD54F] transition-colors shadow-lg" data-id="element-1395">
              Start Onboarding
            </Link>
          </div>
        </div>
      </section>

      {/* Trust Section */}
      <section className="py-16 bg-white" data-id="element-1396">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1397">
          <div className="grid grid-cols-3 md:grid-cols-5 gap-8 items-center justify-items-center opacity-60" data-id="element-1398">
            <img src="https://cdn.magicpatterns.com/uploads/4AYK289tAoefs5UKMeCGRu/Visa_Logo.png" alt="Visa" className="h-8 object-contain" data-id="element-1399" />
            <img src="https://cdn.magicpatterns.com/uploads/1vYo3uhYQcpE27Haf8Bixu/MasterCard_Logo.png" alt="Mastercard" className="h-10 object-contain" data-id="element-1400" />
            <img src="https://cdn.magicpatterns.com/uploads/mkpVZ2yX93dtJTCkJzVjji/UnionPay_Logo.png" alt="UnionPay" className="h-8 object-contain" data-id="element-1401" />
            <img src="https://cdn.magicpatterns.com/uploads/fztxH1Zm6zdRKvuAw79Xb6/PayPak_Logo.png" alt="PayPak" className="h-8 object-contain" data-id="element-1402" />
            <img src="https://cdn.magicpatterns.com/uploads/nYL4tGVTuPASUdRtomRefU/RAAST_Logo.png" alt="RAAST" className="h-10 object-contain" data-id="element-1403" />
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="bg-[#0D3B66] text-white py-20" data-id="element-1404">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-1405">
          <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-1406">
            Ready to transform your payment experience?
          </h2>
          <p className="text-xl mb-10 max-w-3xl mx-auto text-white/90" data-id="element-1407">
            Join thousands of merchants who trust our platform for secure,
            compliant, and efficient payment processing.
          </p>
          <div className="flex flex-col sm:flex-row justify-center space-y-4 sm:space-y-0 sm:space-x-4" data-id="element-1408">
            <Link to="/onboarding" className="bg-[#F5A623] text-[#0D3B66] px-8 py-4 rounded-md font-semibold text-center hover:bg-[#FFD54F] transition-colors shadow-lg" data-id="element-1409">
              Sign Up Now
            </Link>
            <Link to="/login" className="border-2 border-white text-white px-8 py-4 rounded-md font-semibold text-center hover:bg-white hover:text-[#0D3B66] transition-colors" data-id="element-1410">
              Existing Merchant Login
            </Link>
          </div>
        </div>
      </section>
    </div>;
};
export default LandingPage;